import React from "react";

const POSITION_CLASSES = {
    bottomleft: "leaflet-bottom leaflet-left",
    bottomright: "leaflet-bottom leaflet-right",
    topleft: "leaflet-top leaflet-left",
    topright: "leaflet-top leaflet-right",
};

const MapCustomControl = (props) => {
    const { position, containerProps, children } = props;
    return (
        <div className={POSITION_CLASSES[position]}>
            <div className="leaflet-control leaflet-bar" {...containerProps}>
                {children}
            </div>
        </div>
    );
};

export default MapCustomControl;
